<template>
	<div>
		<div class="row">
			<div class="col s12 m8 l10 xl10">
				<div class="row">
					<div class="input-field col s12">
						<i class="material-icons prefix ">search</i>
						<input id="search" type="text" class="validate" v-model="filterTerm">
						<label for="search">Pesquisar</label>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="col s12 m12 l12 xl12">
				<table>
					<col width="5%">
					<col width="25%">
					<col width="25%">
					<col width="40%">
					<col width="5%">
					<thead>
						<tr>
							<th>
								#
							</th>
							<th>
								Avaliador
								<a class="left" href="#" @click="toggleOrder($event, 'user.name')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyAvaliador }">sort</i>
								</a>
							</th>
							<th>
								Ação
								<a class="left" href="#" @click="toggleOrder($event, 'inscricao.acao.titulo')">
									<i class="material-icons" v-bind:class="{ 'red-text': sortPropertyProjeto }">sort</i>
								</a>
							</th>
						    <th>
								Texto
							</th>
							<th>
								Comprovante
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(just, index) in filteredJusts">
							<td>{{ index + 1 }}</td>
							<td><a :href="'/usuario/' + just.user_id + '/edit'">{{ just.user.name }}</a></td>
							<td><a :href="'/inscricaos/' + just.inscricao_id ">{{ just.inscricao.acao.titulo }}</a></td>
							<td>{{ just.texto }}</td>
							<td><center><a :href="'/justificativas/arquivo/' + just.id" class='waves-light btn left cyan darken-1' target='_blank'><i class="material-icons">remove_red_eye</i></a></center></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
		name: "VueJustificaticasList",
		props: [
			'justificativas'
		],
		data () {
			return {
				listaJusts: JSON.parse(this.justificativas),
				sortProperty: 'avaliador',
				sortDirection: 'asc',
				filterTerm: '',
				sortPropertyAvaliador: true,
				sortPropertyEtapa: false,
				sortPropertyEdital: false,
			}
		},
		computed: {
			filteredJusts: function () {
				var self = this
				return _.orderBy(self.listaJusts.filter(function (justificativa) {
					var searchRegex = new RegExp(self.filterTerm, 'i')
					return (
						searchRegex.test(justificativa.user.name) ||
						(justificativa.projeto && searchRegex.test(justificativa.projeto.titulo)) ||
						searchRegex.test(justificativa.edital.ano) ||
						searchRegex.test(self.nomeEtapa(justificativa.etapa))
					)
				}), this.sortProperty, this.sortDirection)
			},
		},
		methods: {
			toggleOrder (ev, field) {
				ev.preventDefault()
				if (this.sortProperty == field){
					if (this.sortDirection == 'asc')
						this.sortDirection = 'desc'
					else
						this.sortDirection = 'asc'
				} else {
					this.iconsColor(this.sortProperty, false)
					this.iconsColor(field, true)
					this.sortProperty = field
					this.sortDirection = 'asc'
				}
			},
			iconsColor(field, value) {
				switch (field) {
					case 'user.name':
						this.sortPropertyAvaliador = value;
						break;
					case 'etapa':
						this.sortPropertyEtapa = value;
						break;
					case 'edital.ano':
						this.sortPropertyEdital = value;
						break;  
					case 'projeto.titulo':
						this.sortPropertyProjeto = value;
						break; 
					default:
				}
			},
			nomeEtapa(etapaId) {
				switch (etapaId) {
					case 1:
						return 'Pertinência';
					case 2:
						return 'Avaliação';
					case 3:
						return 'Recurso Pertinência';  
					case 4:
						return 'Recurso Avaliação';
				}
			}
		}
    }
</script>
